<script>
import Badge from "@/components/atoms/badge";
import Icon from "@/components/atoms/icon";
import Container from "@/components/atoms/container";
import Button from "@/components/atoms/button";

export default {
  name: "ResetMdpFormConfirmation",
  components: {
    Badge,
    Icon,
    Container,
    Button
  },
  props: {
    email: {
      type: String,
      required: false,
      default: ""
    }
  }
};
</script>

<template>
  <div>
    <Container class="u-bgcolor-white ">
      <div class="u-text-center u-pt-lg">
        <Badge
          variant="success"
          circle
          size="xlg"
          class="u-mt-lg"
        >
          <Icon
            name="check"
            variant="white"
          />
        </Badge>
      </div>
      <h1 class="u-pt-md u-font-24 u-color-primary u-mb-md u-text-center">
        Mot de passe mis à jour
      </h1>
      <p class="u-text-center u-mt-md u-mb-sm">
        Un email de confirmation vient d’être envoyé à l’adresse :
      </p>
      <p class="u-text-center  u-mb-lg u-font-500">
        {{ email }}
      </p>
      <div class="u-flex u-flex-column  u-flex-align-center u-mt-lg u-pb-lg">
        <Button
          variant="secondary"
          size="md"
          radius="full"
          class="u-mb-md"
          @click="$showAuth()"
        >
          Je me connecte
        </Button>
        <Button
          variant="primary"
          outline
          size="md"
          radius="full"
          class="u-mb-lg"
          to="/"
        >
          Revenir à l’accueil
        </Button>
      </div>
    </Container>
  </div>
</template>
